import Vue from 'vue'
import CA from '@vue/composition-api'
Vue.use(CA)

import { reactive } from '@vue/composition-api'
import handleValueOrFunction from '@iez/lib/handle-value-or-function'
import './auto-clean/'

export const state = reactive({
  snackbar: null
})

const queue = []

const isActive = ({ id }) =>
  state.snackbar?.id === id

const removeFromQueue = ({ id }) => {
  queue.splice(
    queue.indexOf(snackbar => snackbar.id === id),
    1
  )
}

const remove = ({ id }) => {
  if (isActive({ id })) {
    state.snackbar = null
    setTimeout(() => {
      state.snackbar = queue.shift()
    }, 500)
  } else {
    removeFromQueue({ id })
  }
}

/**
 * {
 *   content: String,
 *   isImportant: Boolean
 * }
 */
let i = 0
const createNewId = () =>
  i++

const createNewSnackbar = ({ snackbar, id }) => ({
  ...snackbar,
  id,
  model: true,
  remove: () => {
    remove({ id })
  }
})

export default () => {
  /**
   * { content }
   */
  const set = snackbar => {
    const id = createNewId()
    handleValueOrFunction({
      valueOrFunction: snackbar,
      callback: snackbar => {
        if (snackbar) {
          const snackbarNew = createNewSnackbar({ snackbar, id })
          if (!state.snackbar && queue.length === 0) {
            state.snackbar = snackbarNew
          } else {
            queue.push(snackbarNew)
          }
        } else {
          remove({ id })
        }
      }
    })

    const unset = () => {
      remove({ id })
    }

    return {
      unset
    }
  }

  const methods = {
    set
  }

  return {
    state,
    ...methods
  }
}
